// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b5605970","385":"6dba7398","437":"4214d66b","481":"d60bf85c","554":"56178e7e","618":"01e134e8","738":"bda229c7","774":"32fb70dc","786":"e4ae6f5b"}[chunkId] + ".chunk.js";
};